import AccordionItem from './accordion-item';

export type AccordionContent = {
  title: string;
  content: Array<string> | string;
};

type AccordionRootProps = {
  contents: Array<AccordionContent>;
  defaultOpenItem?: number;
  allowMultipleOpen?: boolean;
  flow: string;
};

const AccordionRoot = ({ contents }: AccordionRootProps) => (
  <div className='accordion-container'>
    {contents.map(({ title, content }, i) => (
      <AccordionItem key={title} itemIndex={Number(i)} openAccordions={[0]} title={title} content={content} />
    ))}
  </div>
);

export default AccordionRoot;
